/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'pip-model',
    'pip-events',
    'thd-cart-bindings',
    'pip-domain',
    'pip-common.utils'
  ],
  function pipAddToCart(
    $,
    pip,
    pipEvents,
    thdCartBindings,
    pipDomain,
    pipCommonUtils
  ){

    // TODO: Can/does MCC provide these constants?
    var MCC_FULFILLMENT_LOCATION_STH = 'DirectShip';

    var MCC_FULFILLMENT_METHOD_STH = 'ShipToHome';
    var MCC_FULFILLMENT_METHOD_BOSS = 'ShipToStore';
    var MCC_FULFILLMENT_METHOD_BOPIS = 'BOPIS';
    var MCC_FULFILLMENT_METHOD_BODFS = 'DeliverFromStore';
    var MCC_FULFILLMENT_METHOD_APPLIANCE = 'DirectDelivery';

    function getBaseMccAtcRequest(itemId, quantity) {
      var mccAtcRequest = {
        itemId: itemId,
        quantity: quantity
      };

      if (pip.customer.isOptedIntoHdpp && pip.protectionPlan) {
        mccAtcRequest.warrantyItem = {
          itemId: pip.protectionPlan.itemId
        }
      }


      //TODO: collapse this into ProReferral
      if (pip.customer.isOptedIntoAssembly) {
        mccAtcRequest.service = {
          type: 'Assembly',
          selected: true
        }
      }

      // TODO: see above. pip.proreferral will be going away along with assembly so we will really need a rework on how we pass cart these different categories.
      // the mapping of current pro referral categories and assembly types doesn't seem to map 1:1 with the new info we get from techshed. for now just forcing a type
      // so that we can work with the current cart contract.
      if (pip.customer.isOptedIntoProReferral) {
        mccAtcRequest.service = {
          type: getProReferralCategory(),
          selected: true
        }
      }

      if (pip.customer.subscriptions && pip.customer.subscriptions.isOptedIn) {
        mccAtcRequest.subscriptions = {
          frequency: pip.customer.subscriptions.frequency,
          ogModule: document.querySelector('div[data-og-module]').getAttribute('data-og-module')
        }
      }

      if (pip.customer.attachLabor && pip.customer.attachLabor.isOptedIn) {
        if (shouldZipBeDisplayed()) {
          mccAtcRequest.attachedLabor = [
            {
              attachedLaborSku: pip.installationSku.installSku,
              attachedZip: pip.installationSku.zipCode
            }
          ]
        }
        else {
          mccAtcRequest.attachedLabor = [
            {
              attachedLaborSku: pip.installationSku.installSku
            }
          ]
        }
      }

      return mccAtcRequest;
    }

    function shouldZipBeDisplayed() {
      return !!(pip.features && pip.features.attachLaborZipCodeEnabled && pip.installationSku.zipCode && pip.installationSku.installRetailPrice);
    }

    function getProReferralCategory() {
      if(pip.serviceAddOns && pip.serviceAddOns.proReferral) {
        return pip.serviceAddOns.proReferral.category;
      }
      return '';
    }

    function addToCart(cartArray, cartConfig, fulfillmentMethod) {
      thdCartBindings.addToCart(cartArray, cartConfig)
        .on('success', function(response) {
          pipEvents.cart.addToCart.trigger({fulfillmentMethod: fulfillmentMethod});
          if (pip.features.addToCartBackOrderAnalytics) {
            pipEvents.cart.addToCartAnalyticsBackorder.trigger({fulfillmentMethod: fulfillmentMethod});
          }
          if (pip.debugMode) {
            console.log('Cart response:', response);
          }
        })
        .on('error', function(response) {
          if (pip.debugMode) {
            console.log('Cart response:', response);
          }
        });
    }

    function buildRequestAndAddToCart(itemId, quantity, fulfillmentLocation, fulfillmentMethod, isPaypal, bopisToBoss) {
      var atcRequest = getBaseMccAtcRequest(itemId, quantity);
      var misship = false;
      var subscription = !!(pip.customer.subscriptions && pip.customer.subscriptions.isOptedIn);
      var directCheckout = !pip.products.primary.data.info.isAppliance && !isPaypal;
      var isBodfs = fulfillmentMethod === MCC_FULFILLMENT_METHOD_BODFS;

      if(pip.features.bodfsDirectAddToCartOverlayAndPIPSourcingEnabled && isBodfs) {
        directCheckout = false;
      }

      if (fulfillmentLocation) {
        atcRequest.fulfillmentLocation = fulfillmentLocation;
      }

      if (fulfillmentMethod) {
        atcRequest.fulfillmentMethod = fulfillmentMethod;
        if (MCC_FULFILLMENT_METHOD_BOPIS === fulfillmentMethod || MCC_FULFILLMENT_METHOD_BOSS === fulfillmentMethod) {
          misship = true;
        }
      }

      var cartConfig = {
        host: pipDomain.getDomain(),
        channel: pip.platformForCart,
        paypal: !!isPaypal,
        misship: misship,
        subscription: subscription,
        directCheckout: directCheckout,
      };

      if (pip.features && !!pip.features.addToCartQuantityEnabled && bopisToBoss) {
        cartConfig.bopisToBoss = bopisToBoss;
      }

      var bypassBossBopisOverlayEnabled = !!(pip.features.bypassBossBopisOverlayEnabled) && misship;
      cartConfig.bypassBss = bypassBossBopisOverlayEnabled;
      cartConfig.bss = bypassBossBopisOverlayEnabled; // have to pass this in due to bug in thd-cart-bindings

      var items = [atcRequest];

      if (pip.features && pip.features.buyOneGetOneFreeEnabled) {
        var bogoSelectedItem = pipCommonUtils.deepGet(pip, 'products.primary.data.info.bogoSelectedItem');

        if (bogoSelectedItem) {
          cartConfig.bogo = bogoSelectedItem;
          items.push(bogoSelectedItem.itemDetails);
        }
      }

      addToCart(items, cartConfig, fulfillmentMethod);
    }

    function getCartConfig(options) {
      var cartConfig = {
          host: pipDomain.getDomain(),
          channel: pip.platformForCart,
          paypal: false
      };

      if (options) {
        cartConfig = $.extend(cartConfig, options)
      }

      return cartConfig;
    }

    return {

      // TODO: Future support for IRG/FBT.  Should take array as argument.
      // Consider array for all methods.
      addToCartWithoutFulfillment: function addToCartWithoutFulfillment(itemId, quantity) {
        return buildRequestAndAddToCart(itemId, quantity);
      },

      addSthItem: function addSthItem(itemId, quantity) {
        // Pass the zip code to MCC_FULFILLMENT_LOCATION_STH if valid
        var dynamicEtaZipCode = pip.customer.dynamicEtaZipCode;
        if (dynamicEtaZipCode) {
          MCC_FULFILLMENT_LOCATION_STH = dynamicEtaZipCode;
        }
        return buildRequestAndAddToCart(itemId, quantity, MCC_FULFILLMENT_LOCATION_STH, MCC_FULFILLMENT_METHOD_STH, false);
      },

      addBossItem: function addBossItem(itemId, quantity, bopisToBoss) {
        if (pip.customer.localStore && pip.customer.localStore.storenumber) {
          var localStoreId = pip.customer.localStore.storenumber;
        }
        return buildRequestAndAddToCart(itemId, quantity, localStoreId, MCC_FULFILLMENT_METHOD_BOSS, false, bopisToBoss);
      },

      addBopisItem: function addBopisItem(itemId, quantity) {
        var storeId = pip.customer.storeForPurchase;

        return buildRequestAndAddToCart(itemId, quantity, storeId, MCC_FULFILLMENT_METHOD_BOPIS, false);
      },

      addBodfsItem: function addBodfsItem(itemId, quantity, deliveryZip) {
        return buildRequestAndAddToCart(itemId, quantity, deliveryZip, MCC_FULFILLMENT_METHOD_BODFS, false);
      },

      addAppliance: function addAppliance(itemId, quantity, deliveryZip) {
        return buildRequestAndAddToCart(itemId, quantity, deliveryZip, MCC_FULFILLMENT_METHOD_APPLIANCE, false);
      },

      addMultiItem: function multiItem(cartObj){
        var url = 'https://' + pip.remoteHosts.secureBrowse + '/mcc-cart/v2/Cart';

        return $.ajax({
          type: 'POST',
          url: url,
          data: JSON.stringify(cartObj),
          timeout: 60000,
          xhrFields: { withCredentials: true },
          headers: {
            "Accept" : "application/json; charset=utf-8",
            "Content-Type" : "application/json"
          }
        });
      },
      addIRGItem: function addIRGItem(itemId, itemType) {
        var fulfillmentMethod = itemType === 'MAJOR_APPLIANCE' ? MCC_FULFILLMENT_METHOD_APPLIANCE : MCC_FULFILLMENT_METHOD_STH;
        return buildRequestAndAddToCart(itemId, 1, null, fulfillmentMethod, false);
      },
      paypalAddToCart: function paypalAddToCart(type) {
        if(pip && pip.features && pip.features.reactFulfillmentTilesEnabled){
          var fulfillmentLocation = '';
          if(type === MCC_FULFILLMENT_METHOD_STH) {
            fulfillmentLocation = MCC_FULFILLMENT_LOCATION_STH;
          }
          else if(type === MCC_FULFILLMENT_METHOD_BODFS) {
            fulfillmentLocation = pip.customer.localStore && pip.customer.localStore.zipCode? pip.customer.localStore.zipCode : '';
          }
          else {
            fulfillmentLocation = pip.customer.localStore && pip.customer.localStore.storenumber? pip.customer.localStore.storenumber : '';
          }
          buildRequestAndAddToCart(pip.products.primary.data.itemId, pip.customer.quantity, fulfillmentLocation, type, true);
        }else{
          var fulfillmentLocation = (type === 'ShipToHome') ? MCC_FULFILLMENT_LOCATION_STH : pip.customer.localStore.storenumber;
          buildRequestAndAddToCart(pip.products.primary.data.itemId, pip.customer.quantity, fulfillmentLocation, type, true);
        }
      },

      addMultipleApplianceItems : function addMultipleApplianceItems(cartObject, options) {
        var cartConfigOptions = options || {};
        addToCart(cartObject, getCartConfig(cartConfigOptions), MCC_FULFILLMENT_METHOD_APPLIANCE);
      },

      addPackageItems : function addPackageItems(items, options, fulfillmentMethod) {
        var cartConfigOptions = options || {};
        addToCart(items, getCartConfig(cartConfigOptions), fulfillmentMethod);
      }
	};
});

}.call(window));